export default function ProgressBar({ progress }) {
  const radius = 9 // 원의 반지름
  const circumference = 2 * Math.PI * radius // 원의 둘레 계산

  //   진행 상태에 맞게 stroke-dashoffset 계산
  const offset = circumference - (progress / 100) * circumference

  return (
    <svg width='22' height='22' viewBox='0 0 22 22' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11' cy='11' r={radius} stroke='#D9D9D9' strokeWidth='4' fill='none' />
      <circle
        cx='11'
        cy='11'
        r={radius}
        stroke='#00BF40'
        strokeWidth='4'
        fill='none'
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap='round'
        transform='rotate(-90 11 11)'
      />
    </svg>
  )
}
